module.exports = __webpack_public_path__ + "static/img/demo-update.95a2391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-update.png
// module id = Nd+7
// module chunks = 0